import { call, put, takeLatest } from "@redux-saga/core/effects";
import {
  errorAddTimesheet,
  errorDownloadFileById,
  errorDownloadInvoiceAction,
  errorEditTimesheets,
  errorGenerateInvoice,
  errorGetTimesheetById,
  errorTimesheetAppAction,
  errorTimesheetById,
  errorTimesheetListAction,
  errorTimesheetsAction,
  errorTimesheetsByIdForUserPage,
  responseAddTimesheet,
  responseDownloadFileById,
  responseDownloadInvoiceAction,
  responseEditTimesheets,
  responseGenerateInvoice,
  responseGetTimesheetById,
  responseTimesheetAppAction,
  responseTimesheetById,
  responseTimesheetListAction,
  responseTimesheetsAction,
  responseTimesheetsByIdForUserPage,
  TIMESHEET_ACTION,
} from "./TimeSheetActionCreator";
import TimeSheetService from "../../Services/RestApiManager/TimesheetManager/TimesheetRequestService";
import { downloadBufferToExcel, downloadBase64AsFile1, downloadFile } from "../../helpers/Localstorage";

export function* timeSheetByProjectIdRequest(action) {
  try {
    const response = yield call(
      TimeSheetService.shared.timesheetByIdRequest,
      action.data
    );
    yield put(responseTimesheetById(response));
  } catch (error) {
    yield put(errorTimesheetById(error));
  }
}

export function* timeSheetsByProjectIdRequestForUserPage(action) {
  try {
    const response = yield call(
      TimeSheetService.shared.timeSheetsByProjectIdRequestForUserPage,
      action.data
    );
    yield put(responseTimesheetsByIdForUserPage(response));
  } catch (error) {
    yield put(errorTimesheetsByIdForUserPage(error));
  }
}

export function* addNewTimesheetRequest(action) {
  try {
    const response = yield call(
      TimeSheetService.shared.addNewTimesheetRequest,
      action.data
    );
    yield put(responseAddTimesheet(response));
  } catch (error) {
    yield put(errorAddTimesheet(error));
  }
}

export function* editTimesheetsRequest(action) {
  try {
    const response = yield call(
      TimeSheetService.shared.editTimesheetsRequest,
      action.data
    );
    yield put(responseEditTimesheets(response));
  } catch (error) {
    yield put(errorEditTimesheets(error));
  }
}

export function* getTimesheetByIdRequest(action) {
  try {
    const response = yield call(
      TimeSheetService.shared.getTimesheetByIdRequest,
      action.data
    );
    yield put(responseGetTimesheetById(response));
  } catch (error) {
    yield put(errorGetTimesheetById(error));
  }
}

export function* timesheetsActionRequest(action) {
  try {
    const response = yield call(
      TimeSheetService.shared.timesheetsActionRequest,
      action.data
    );
    yield put(responseTimesheetsAction(response));
  } catch (error) {
    yield put(errorTimesheetsAction(error));
  }
}

export function* generateInvoiceRequest(action) {
  try {
    const response = yield call(
      TimeSheetService.shared.generateInvoiceRequest,
      action.data
    );
    if (response) {
      downloadBufferToExcel(response)
      yield put(responseGenerateInvoice(response));
    }
  } catch (error) {
    yield put(errorGenerateInvoice(error));
  }
}

export function* downloadInvoiceRequest(payload) {
  try {
    const response = yield call(
      TimeSheetService.shared.downloadInvoiceRequest,
      payload.data
    );
    if (response) {
      downloadBufferToExcel(response)
      yield put(responseDownloadInvoiceAction());
    }
  } catch (error) {
    yield put(errorDownloadInvoiceAction(error));
  }
}

export function* downloadTimeSheetRequest(payload) {
  try {
    const response = yield call(
      TimeSheetService.shared.downloadTimeSheetRequest,
      payload.data
    );
    if (response) {
      downloadBufferToExcel(response)
      yield put(responseDownloadInvoiceAction());
    }
  } catch (error) {
    yield put(errorDownloadInvoiceAction(error));
  }
}
 export function * TimesheetListRequest(action){
  try {
        const response = yield call(TimeSheetService.shared.timesheetListRequest, action.data);
        yield put(responseTimesheetListAction(response));
      } catch (error) {
        yield put(errorTimesheetListAction(error));
      }
 }
 export function * TimesheetAppRequest (action){
  try{
    const response = yield call(TimeSheetService.shared.timesheetAppRequest,action.data);
    yield put(responseTimesheetAppAction(response));
  } catch (error) {
    yield put (errorTimesheetAppAction(error));
  }
 }
 export function* downloadFileRequest(payload) {
  try {
    const response = yield call(
      TimeSheetService.shared.downloadFileByIdRequest,
      payload.data
    );
    if (response.blobUrl) {
      downloadBase64AsFile1(response.fileName, response.fileType, response.blobUrl);
      yield put(responseDownloadFileById('File downloaded successfully'));
    }
  } catch (error) {
    yield put(errorDownloadFileById(error));
  }
}


export function* timeSheetWatcherSaga() {
  yield takeLatest(TIMESHEET_ACTION.REQUEST_TIMESHEET_BY_ID,timeSheetByProjectIdRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_TIMESHEETS_BY_ID_FOR_USER_PAGE,timeSheetsByProjectIdRequestForUserPage);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_ADD_TIMESHEET,addNewTimesheetRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_EDIT_TIMESHEETS,editTimesheetsRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_GET_TIMESHEET_BY_ID,getTimesheetByIdRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_TIMESHEETS_ACTION,timesheetsActionRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_GENERATE_INVOICE,generateInvoiceRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_DOWNLOAD_INVOICE,downloadInvoiceRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_DOWNLOAD_TIMESHEET,downloadTimeSheetRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_TIMESHEET_LIST,TimesheetListRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_TIMESHEET_APP,TimesheetAppRequest);
  yield takeLatest(TIMESHEET_ACTION.REQUEST_DOWNLOAD_FILE_BY_ID,downloadFileRequest);
}
